import React from 'react';
import { Body } from '@indigo-ag/component-module';

import { NewPage } from 'core/components';

const UnauthorizedPageComponent: React.FunctionComponent = () => {
  return (
    <NewPage title="Unauthorized">
      <Body>You need a valid role in order to navigate in the application, please reach out to support.</Body>
    </NewPage>
  );
};

export const UnauthorizedPage = UnauthorizedPageComponent;
